export type GetIfDefinitionForReferenceRequest = {
  dfnSetVerNum: string;
  bdryIdList: BoundaryId[];
};

export type BoundaryId = {
  idx?: Number;
  bdryId: string;
  bdryType: string;
  dstDipByRgn?: string;
  dstOtbdId?: string;
  srcInbdId?: string;
};
